export const PAIRING = 'PAIRING';
export const UNPAIRING = 'UNPAIRING';
export const ERROR = 'ERROR';
export const PAIRED = 'PAIRED';
export const UNPAIRED = 'UNPAIRED';
export const WAIT_SET_ADDR_RES = 'WAIT_SET_ADDR_RES';
export const WAIT_RESET_ADDR_RES = 'WAIT_RESET_ADDR_RES';
export const WAIT_GET_GUID_RES = 'WAIT_GET_GUID_RES';
export const WAIT_SET_GREEN_LED_RES = 'WAIT_SET_GREEN_LED_RES';
export const TRAFFIC_ISSUE_SUSPECT = 'TRAFFIC_ISSUE_SUSPECT';
export const UNKNOWN_ENUM = 'UNKNOWN';
export const DOWNLOAD = 'DOWNLOAD';
export const SWITCH = 'SWITCH';
export const DOWNLOADING = 'DOWNLOADING';
export const SWITCHING = 'SWITCHING';
export const OK = 'OK';
export const DISCONNECTED = 'DISCONNECTED';
export const CONNECTED = 'CONNECTED';
export const KEEP_ALIVE_INTERVAL_MIN = 60;
export const KEEP_ALIVE_INTERVAL_MAX = 480;
export const AGGREGATED_DATA_INTERVAL_MIN = 60;
export const AGGREGATED_DATA_INTERVAL_MAX = 1440;
export const AGGREGATED_DATA_RESOLUTION_MIN = 1;
export const AGGREGATED_DATA_RESOLUTION_MAX = 60;
export const FACTORY_DEFAULTS = 'FACTORY_DEFAULTS';
export const UPGRADE_PROGRESS_INFO_POLLING_INTERVAL = 1000;
export const UPGRADE_STATUS_POLLING_INTERVAL = 5000;
export const UPGRADE_PERCENTAGE_INTERVAL = 1500;
export const RESET = 'RESET';
export const REBOOT = 'REBOOT';
export const INTERRUPTED = 'INTERRUPTED';
export const UNKNOWN = 'Unknown';
export const STARTED = 'Started';
export const COMPLETED = 'Completed';
export const FAILED = 'Failed';
export const UPGRADING = 'Upgrading';
export const RESPONSE_SUCCESSFUL = 200;
export const UPGRADE_INFO_ERROR_MESSAGE = "we were unable to access some of the upgrade information";
export const UPGRADE_START_ERROR_MESSAGE = "we were unable start the upgrade process";
export const UPGRADE_PROGRESS_ERROR_MESSAGE = "we were unable to access the upgrade progress information";
export const WARNING = 'warning';
export const DANGER = 'danger';
export const SUCCESS = 'success';
export const STATUS_STARTED = 'started';
export const STATUS_PROGRESSING = 'progressing';
export const STATUS_FAILED = 'failed';
export const STATUS_SUCCEEDED = 'succeeded';
export const UPGRADE_LATEST_OS_PROMPT = 'The operation system is already upgraded to the latest version, Are you sure you want to run the upgrade anyway?';
export const UPGRADE_OS_PROMPT = 'Are you sure you want to start the upgrade?';
export const NOT_AVAILABLE = 'N/A';
export const NOT_FOUND = 404;
export const DISABLED = 'DISABLED';
export const NOT_SUPPORTED = 'NOT_SUPPORTED';
